const setInsuranceTab = (insuranceData,requestJSON) =>{
    if (insuranceData !== undefined && insuranceData !== null && insuranceData.length !== 0) {

        let mapInsuranceData = [];
        mapInsuranceData.push(...insuranceData.map(obj => ({...obj})));

        mapInsuranceData.forEach(item=>{
            item.type = item.settedInsuranceType !== undefined && item.settedInsuranceType !== null && item.settedInsuranceType.value !== "" ? item.settedInsuranceType.value : ""; delete item.settedInsuranceType;
            item.bin = item.settedBin !== undefined && item.settedBin !== "" ? item.settedBin : ""; delete item.settedBin;
           
            if(item.settedPcn !== undefined && item.settedPcn !== "")
            {
                item.pcn = item.settedPcn;
            }
           
            if(item.settedGroup !== undefined && item.settedGroup !== "")
            {
                item.group = item.settedGroup;
            }

            if(item.settedIdNumber !== undefined && item.settedIdNumber !== "")
            {
                item.identificationNumber = item.settedIdNumber;
            }
          
            if(item.settedPersonCode !== undefined && item.settedPersonCode !== "")
            {
                item.personCode = item.settedPersonCode
            }
            else{
                item.personCode = "00"
            }
            
            if(item.settedOtherDescription !== undefined && item.settedOtherDescription !== "")
            {
                item.description = item.settedOtherDescription;
            }
            item.createdDate = new Date();
            delete item.id; delete item.settedOtherDescription; delete item.settedPersonCode; 
            delete item.settedIdNumber; delete item.settedGroup; delete item.settedPcn;
        })

        requestJSON = { ...requestJSON, "insurances": mapInsuranceData };
    }
    return requestJSON;
}

export default setInsuranceTab